<input (click)="toggleSelect($event)" type="checkbox" [checked]="checked" class="select">
<mat-icon class="sub" *ngIf="item?.children?.length && item.level < 2" (click)="toggleExpansion($event)">chevron_right</mat-icon>
<div class="title">
  <span [innerHTML]="(item?.title || item?.data?.title) | highlightSearch: searchValue"></span>
</div>
<div class="good-to-know" *ngIf="item?.data?.type === 'alphabet'">
  <input *ngIf="!!(item.content?.goodToKnow || item.data.content?.goodToKnow)" type="checkbox" [checked]="true" disabled>
</div>
<div class="categories" *ngIf="!!categories?.length">
  {{getCategories()}}
</div>
<div class="order" *ngIf="showOrder">
  <span>{{(item.content?.order || item.data.content?.order)}}</span>
</div>
<div *ngIf="['activity', 'event'].includes(type)" class="next-execution">
  {{ calculateNextExecution(item.content || item.data.content) | date: 'EE, dd.MM.yyyy' | translateDate:'dd, DD.MM.YYYY' }}
</div>
<div class="drag" *ngIf="!readOnly && !noDragAndDropItems.includes(type)"></div>
<dynamic-content-table-active-state [item]="item" [app]="app"></dynamic-content-table-active-state>
<div class="languages" *ngIf="!short">
  <img class="language" src="../../../../../assets/img/languages/{{item.data.lang}}.jpg" />
  <img *ngFor="let tran of (item.translation || item.data.translation)" class="language" src="../../../../../assets/img/languages/{{tran}}.jpg" />
</div>
<div class="created" *ngIf="(!!item?.created || !!item?.data?.created) && !medium">{{item?.data?.created | date:'dd.MM.YYYY'}}</div>
<div class="actions">
  <ng-container *ngIf="!item?.global && !item?.data?.global">
    <button *ngIf="showPreview" [matTooltip]="'general.preview' | translate" (click)="action('preview', item, $event)"><mat-icon>visibility</mat-icon></button>
    <button *ngIf="['gastronomy', 'feedback', 'voting'].includes(type)" [matTooltip]="'dynamicContent.detail' | translate" (click)="action('detail', item, $event)"><mat-icon>view_list</mat-icon></button>
    <button [matTooltip]="'dynamicContent.edit' | translate" (click)="action('edit', item, $event)" [disabled]="readOnly"><mat-icon>edit</mat-icon></button>
    <button [matTooltip]="'dynamicContent.remove' | translate" (click)="action('delete', item, $event)"><mat-icon>delete</mat-icon></button>
    <button [matTooltip]="'dynamicContent.addChild' | translate" class="add-button" *ngIf="hasAddChild() && !readOnly" (click)="action('addChild', item, $event)" [disabled]="readOnly"><mat-icon>add</mat-icon></button>
  </ng-container>
  <ng-container *ngIf="!!item?.global || !!item?.data?.global">
    <button [matTooltip]="'dynamicContent.global' | translate"><mat-icon>language</mat-icon></button>
    <button [matTooltip]="'dynamicContent.remove' | translate" (click)="action('delete', item, $event)"><mat-icon>delete</mat-icon></button>
  </ng-container>
</div>
